<script setup lang="ts">
import { MMLink, MMText, MMIcon } from '@mm-frontend/mm-web-ui-kit';
import { useCitiesModal } from '~/features/citiesModal';
import { useCityStore } from '~/features/store';

const { currentCity } = useCityStore();
const { openCitiesModal } = useCitiesModal();

function handleCityClick() {
  openCitiesModal();
}
</script>

<template>
  <MMLink design="neutral" @click="handleCityClick">
    <MMIcon name="location-pin" :height="24" :width="24" />
    <MMText font="Body M/Regular" class="city-snippet__text">Город</MMText>
    <MMText font="Body M/Regular" color="tertiary">{{ currentCity?.name }}</MMText>
  </MMLink>
</template>

<style lang="stylus" scoped>
.city-snippet
  &__text
    flex 1
</style>
